import Axios from 'axios';

import ls from 'local-storage';

import baseConstants from '@constants/baseConstants';

export const saveAlerts = async (updateArea, alerts) => {
    let globalAlerts = {};
    for (const area of baseConstants.AREAS) {
        globalAlerts = {
            ...globalAlerts,
            [area]: area === updateArea ? [...alerts] : ls.get(`nw_config_${area}-read-alerts`) || [],
        };
    }
    await Axios.post('/userclientconfigurations', {
        Name: 'alerts',
        JsonData: JSON.stringify(globalAlerts),
    });
};
